
(() => {
  if (window.jQuery && jQuery.flexslider) {
    jQuery.flexslider.defaults.slideshow = false;
    jQuery.flexslider.defaults.keyboard = false;
  }
  const stopSliders = () => {
    if (!window.jQuery) return;
    jQuery('.flexslider').each(function(){const slider=jQuery(this).data('flexslider');if(slider){slider.stop();slider.manualPause=true;slider.vars.slideshow=false;}});
  };
  document.addEventListener('DOMContentLoaded',stopSliders);
  window.addEventListener('load',stopSliders);

  const visible = e => !!(e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden');
  const search = document.getElementById('search');
  const opener = document.getElementById('search-toggle');
  if (search && opener) {
    let wasOpen = false;
    const observer = new MutationObserver(() => {
      const open = visible(search);
      [...search.parentElement.children].filter(e=>e!==search).forEach(e=>{e.inert=open;});
      if (wasOpen && !open) opener.focus();
      wasOpen = open;
      opener.setAttribute('aria-expanded', String(open));
    });
    observer.observe(search, { attributes:true, attributeFilter:['style'] });
    search.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); search.querySelector('.search-close').click(); }
      if (e.key === 'Tab') {
        const items = [...search.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(visible);
        const first = items[0], last = items[items.length-1];
        if (e.shiftKey && document.activeElement === first) {e.preventDefault(); last.focus();}
        else if (!e.shiftKey && document.activeElement === last) {e.preventDefault(); first.focus();}
      }
    });
  }
  document.querySelectorAll('.nav ul.menu > li').forEach(li => {
    const link = li.querySelector('a.sub-menu');
    if (!link) return;
    link.setAttribute('aria-expanded','false');
    li.addEventListener('focusin', () => {li.classList.remove('a11y-menu-dismissed');link.setAttribute('aria-expanded','true');});
    li.addEventListener('focusout', e => {if(!li.contains(e.relatedTarget)){li.classList.remove('a11y-menu-dismissed');link.setAttribute('aria-expanded','false');}});
    li.addEventListener('keydown', e => {if(e.key === 'Escape'){e.preventDefault();link.focus();li.classList.add('a11y-menu-dismissed');link.setAttribute('aria-expanded','false');}});
  });
  const nameSliders = () => {
    document.querySelectorAll('.flex-prev').forEach(e=>e.setAttribute('aria-label',document.documentElement.dataset.previousSlide));
    document.querySelectorAll('.flex-next').forEach(e=>e.setAttribute('aria-label',document.documentElement.dataset.nextSlide));
  };
  // Fade slides remain rendered at opacity zero; exclude their links from focus.
  const syncHomeSlides = () => {
    stopSliders();
    document.querySelectorAll('.homepage_slider .slides > li').forEach(slide => {
      const hidden = !slide.classList.contains('flex-active-slide');
      slide.inert = hidden;
      slide.setAttribute('aria-hidden', String(hidden));
    });
  };
  document.querySelectorAll('.homepage_slider .slides').forEach(slides => {
    new MutationObserver(syncHomeSlides).observe(slides, {
      subtree: true, attributes: true, attributeFilter: ['class'], childList: true
    });
  });
  syncHomeSlides();
  stopSliders();
  nameSliders();
  new MutationObserver(nameSliders).observe(document.body,{childList:true,subtree:true});
})();
